<template>
<div class="row">
  <div class="column col-md-2">
    <label>Description</label>
    <div class="multiple-rows"> {{ Description }} </div>
    <p></p>
    <label>Internal Note</label>
    <div class="multiple-rows"> {{ InternalNote }} </div>
    <p></p>
    <label>Unit</label>
    <div>{{ UnitType }}</div>
    <p></p>
  </div>

  <span v-if='showBUCCCategColumn'>
    <span v-if="showMixBusinessUnitAndCostCenter || useBUAndCCSetting" class="column col-md-2 wrap">
      <label>Business Unit and Cost Center</label>
      <div>{{ BusinessUnitAndCostCenter }}</div>
      <p></p>
    </span>

    <span v-else class="column col-md-2">
      <span v-if='hasBusinessUnitSetting'>
        <label>Business Unit</label>
        <div class="multiple-rows">{{ BU }}</div>
        <p></p>
      </span>
      <span v-if='hasCostCenterSetting'>
        <label>Cost Center</label>
        <div class="multiple-rows">{{ CC }}</div>
        <p></p>
      </span>
      <div class="row" v-if="this.model.isFeeDiscountItem === false">
        <span class="col-md-5">
          <label>Category Ref ID</label>
          <br>
          <span class="multiple-rows">{{ CategoryRefId }}</span>
          <p></p>
        </span>
      </div>
    </span>
  </span>

  <span v-if='showSavingsFields' class="column col-md-2">
    <label>Rates</label>
    <div class="row">
      <span class='col-md-5'>SGR</span>
      <v-money :supplementalPrecision="supplementalPrecision" class='col-md-7 text-right'>{{ model.unitPriceSGR }}</v-money>
      <p></p>
      <span class='col-md-5'>Preferred</span>
      <v-money :supplementalPrecision="supplementalPrecision" class='col-md-7 text-right'>{{ model.unitPricePreferredRate }}</v-money>
      <p></p>
      <span class='col-md-5'>Negotiated</span>
      <v-money :supplementalPrecision="supplementalPrecision" class='col-md-7 text-right'>{{ model.unitPriceNegotiatedRate }}</v-money>
      <p></p>
    </div>
  </span>

  <span :class="taxesAndFeesClass">
    <label>Taxes</label>

    <div class ='row' v-if="existsAtLeastOneTax">
      <span v-for='tax in allTaxes' v-bind:key="tax.name">
        <div v-if="showValue(tax.value) && tax.isChecked">
          <span class='col-md-5'>{{ tax.name }}</span>
          <v-money class='col-md-7 text-right'>{{ tax.value }}</v-money>
        </div>
      </span>
    </div>
    <div v-else>
      None
    </div>
    <p></p>
  </span>

  <span :class="taxesAndFeesClass">
    <label>Fees</label>

    <div class="row" v-if="existsAtLeastOneFee">
      <span v-for='fee in model.fees' v-bind:key="fee.name">
        <div v-if="showValue(fee.value)">
          <span class='col-md-5'>{{ fee.name }}</span>
          <v-money class='col-md-7 text-right'>{{ fee.value }}</v-money>
        </div>
      </span>
    </div>
    <div v-else>
      None
    </div>
  </span>

  <span class="col-md-2">
    <label>Discounts</label>
    <div v-if='discountExists'>
      <v-money>{{ -model.discountAmount }}</v-money>
    </div>
    <div v-else>
      None
    </div>
    <p></p>
  </span>
</div>
</template>

<script>
export default {
  props: {
    model: Object,
    currency: String
  },

  methods: {
    showValue(value) {
      if (Number(value) !== 0) {
        return true
      }
      return false
    },

    allTaxesComputed() {
      this.allTaxes = []
      if (this.model.taxes) {
        this.model.taxes.map(tax => {
          if (tax.isChecked) {
            this.allTaxes.push(utils.copy(tax))
          }
        })
      }

      if (this.model.fees) {
        this.model.fees.map(fee => {
          if (fee.taxes) {
            fee.taxes.map(feetax => {
              let exists = false
              this.allTaxes.map(alltax => {
                if (alltax.name.trim() === feetax.name.trim() && feetax.isChecked) {
                  alltax.value = Number(alltax.value) + Number(feetax.value)
                  exists = true
                }
              })
              if (exists === false) {
                if (feetax.isChecked) {
                  this.allTaxes.push(utils.copy(feetax))
                }
              }
            })
          }
        })
      }
      return this.allTaxes
    },

    getHasCostCenterSetting() {
      return global.app.getUser.settings.HasCostCenter && Number(global.app.getUser.settings.HasCostCenter) === 1 ||
        this.model.hasCostCenter
    },

    getHasBusinessUnitSetting() {
      return global.app.getUser.settings.HasBusinessUnit && Number(global.app.getUser.settings.HasBusinessUnit) === 1 ||
        this.model.hasBusinessUnit
    },

    getUseBUAndCCSetting() {
      return global.app.getUser.settings.UseBusinessUnitAndCostCenterMapping && Number(global.app.getUser.settings.UseBusinessUnitAndCostCenterMapping) === 1 ||
        this.model.useBusinessUnitAndCostCenterMapping
    }
  },

  data() {
    return {
      allTaxes: [],
      // TODO: replace
      hasCostCenterSetting: this.getHasCostCenterSetting(),
      hasBusinessUnitSetting: this.getHasBusinessUnitSetting(),
      useBUAndCCSetting: this.getUseBUAndCCSetting()
    }
  },

  computed: {
    BU() {
      return this.model.costCenterAndBusinessUnit && this.model.costCenterAndBusinessUnit.businessUnitName || 'None'
    },

    CC() {
      if (this.model.costCenterAndBusinessUnit) {
        let name = this.model.costCenterAndBusinessUnit.costCenterName
        let code = this.model.costCenterAndBusinessUnit.costCenterNo

        if (name || code) {
          return name && (name.indexOf(code) === -1 || name.trim() !== code.trim())
            ? code + ' (' + name + ')'
            : code
        }
      }
      return 'None'
    },

    BusinessUnitAndCostCenter() {
      return this.model.costCenterAndBusinessUnit && this.model.costCenterAndBusinessUnit.costCenterAndBusinessUnitName || 'None'
    },

    Description() {
      return this.model.description || 'None'
    },

    InternalNote() {
      return this.model.internalNote || 'None'
    },

    CategoryRefId() {
      return this.model.referenceId || 'None'
    },

    UnitType() {
      return this.model.unitType || 'None'
    },

    showMixBusinessUnitAndCostCenter() {
      return this.model.costCenterAndBusinessUnit && this.model.costCenterAndBusinessUnit.costCenterAndBusinessUnitName
    },

    existsAtLeastOneTax() {
      this.allTaxesComputed()

      let exists = false
      this.allTaxes && this.allTaxes.map(item => {
        if (Number(item.value) !== 0 && item.isChecked) {
          exists = true
        }
      })
      return exists
    },

    existsAtLeastOneFee() {
      let exists = false
      this.model.fees && this.model.fees.map(item => {
        if (Number(item.value) !== 0) {
          exists = true
        }
      })
      return exists
    },

    discountExists() {
      let number = Number(this.model.discountAmount)
      if (number && number !== 0) {
        return true
      }
      return false
    },

    showBUCCCategColumn() {
      return this.showMixBusinessUnitAndCostCenter ||
        this.useBUAndCCSetting ||
        this.hasBusinessUnitSetting ||
        this.hasCostCenterSetting ||
        this.model.isFeeDiscountItem === false
    },

    showSavingsFields() {
      return typeof this.model.poQuantity === 'undefined' && this.model.isFeeDiscountItem === false &&
        // when using savings fields, amounts are saved as strings &&
        (this.model.unitPriceSGR || this.model.unitPricePreferredRate || this.model.unitPriceNegotiatedRate) &&
        !(this.model.unitPriceSGR === 0 &&
          this.model.unitPricePreferredRate === 0 &&
          this.model.unitPriceNegotiatedRate === 0)
    },

    taxesAndFeesClass() {
      return 'column ' + (this.showSavingsFields ? 'col-md-2' : 'col-md-3')
    },

    supplementalPrecision() {
      try {
        var r = (this.model.unitPrice + '').split('.')
        let has8Digits = r && r.length > 1 && r[1].length > 2
        return has8Digits ? 6 /* 8 digits */ : 0 /* 2 digits */
      } catch (e) {
        return 0 /* 2 digits */
      }
    }
  }
}
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";
@import "~@/assets/sass/font-awesome/_variables.scss";
@import "~@/assets/sass/_form_fields.scss";

.multiple-rows {
    white-space: pre-line;
    text-overflow: ellipsis;
}

.column {
  @include theme {
  border-right: 1px solid v(background-light);
  }
  padding-left: 10px;

  &.wrap {
    white-space: normal;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/_modules/I2P/components/itemDetails.vue